import React from "react";
import Row from "@amzn/meridian/row";
import useBreakpoint from "@amzn/meridian/use-breakpoint";
import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from "../../constants/constants";
import Subcolumn from "./subColumn";

const approvedLists = ({ processPaths }) => {
  const isMobile = useBreakpoint(MOBILE_BREAKPOINT) === "smaller";
  const isTablet = useBreakpoint(TABLET_BREAKPOINT) === "smaller";
  const columnLen = 15;
  const totalColumnNumber = Math.ceil(processPaths.length / columnLen);
  processPaths.sort();

  if (isMobile || isTablet) {
    return (
      <Row alignmentVertical={"top"}>
        <Subcolumn
          processPaths={processPaths}
          columnNum={0}
          columnLen={columnLen}
          isOneColumn={true}
        ></Subcolumn>
      </Row>
    );
  }

  return (
    <Row spacing={"600"} width={"90em"} alignmentVertical={"top"}>
      {Array.from({ length: totalColumnNumber }, (_, index) => index).map(
        (_, index) => (
          <Subcolumn
            processPaths={processPaths}
            columnNum={index}
            columnLen={columnLen}
            isOneColumn={false}
          ></Subcolumn>
        )
      )}
    </Row>
  );
};

export default approvedLists;
